
import { i18nText } from '@/locales';
import {Component} from "vue-property-decorator";
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import { VisitCreateRequestType } from "./visitCreate.types";
import { IClientsListItem } from "@/entity/clients/clients.types";


@Component
export default class VisitCreateForm extends Form{
    status_id = 1;
    salon_id = 0;

    visit_date: string | null = null;
    visit_date_time: string | null  = null;
    visit_date_time_start: any |  null = null;
    visit_date_time_end: any | null = null;
    @Validate(required, i18nText("Введите длительность"))
    visit_duration: string | null  = null;

    comment: string | null  = null;
    color: string | null  = null;
    category: string | null  = null;
    note: string | null  = null;
    another_client: boolean | null  = null; 

    service_data: any[] | null = null;
    consumables_data: any[] | null = null;
    products: any[] | null = null;
    certificates: any[] | null = null;
    memberships: any[] | null = null;

    @Validate(required, i18nText("Выберите косметолога"))
    cosmetologists_id: number | null  = null;
    product_id: number | null  = null;
    certificate_id: number | null  = null;
    membership_id: number | null  = null;
    notification_id: number | null  = null;
    history_changes_id: number | null  = null;
    payment_id: number | null  = null;
    total_amount: number | number = 0;


    client_id: number | string | null = null;
    @Validate(required, i18nText("Выберите клиента"))
    client_name: string | null = null;
    client_phone: string | null = null;
    client_source: string | string = ' ';
    client_email: string | null = null;

    cosmetologist_fio: string | null = null;

    clienta_change_date: any[] | null = null;

    visit_general_flag = false;
    service_visits_group: any [] | null = null;

    certificates_info: any[] | null = null;
    memberships_info: any[] | null = null;

    paid: any | null = null;
    sold: any | null = null;

    client_visit_info: {
        count_visits: number,
        visit_last_date: string
    } = {
        count_visits: 0,
        visit_last_date: ''
    };

    new_client: boolean = true;

    worker_schedule: boolean = false;
    worker_schedule_break_time: boolean = false;
    worker_schedule_not_work_day: boolean = false;


    getFormData() : VisitCreateRequestType {
        return {
            status_id: this.status_id,
            salon_id: this.salon_id,

            visit_date: this.visit_date,
            visit_date_time: this.visit_date_time,
            visit_date_time_start: this.visit_date_time_start,
            visit_date_time_end: this.visit_date_time_end,
            visit_duration: this.visit_duration,
            
            comment: this.comment,
            color: this.color,
            category: this.category,
            note:  this.note,
            another_client: this.another_client,
            
            client_id: this.client_id,
            client_phone: this.client_phone,
            client_email: this.client_email,
            client_name: this.client_name,
            client_source: this.client_source,

            service_data: this.service_data,
            consumables_data: this.consumables_data,
            products: this.products,
            certificates: this.certificates,
            memberships: this.memberships,
            clienta_change_date: this.clienta_change_date,
            
            cosmetologists_id: this.cosmetologists_id,
            product_id: this.product_id,
            certificate_id: this.certificate_id,
            membership_id: this.membership_id,
            notification_id: this.notification_id,
            history_changes_id: this.history_changes_id,
            payment_id: this.payment_id,
            total_amount: this.total_amount,
            new_client: this.new_client,
            worker_schedule: this.worker_schedule,
            worker_schedule_break_time: this.worker_schedule_break_time,
            worker_schedule_not_work_day: this.worker_schedule_not_work_day,
        }
    }

    // setSource(sources: ISources[]){
    //     this.client_source = sources;
    // }

    setFormData(client: IClientsListItem | undefined): void {
        console.log('in set');
        console.log(client);
        if(client !== undefined){
            this.client_id          = client.id;
            this.client_name        = client.name;
            this.client_phone       = client.phone;
            this.client_email       = client.email;
            this.memberships_info   = client.memberships_info;
            this.certificates_info  = client.certificates_info;
            this.paid               = client.paid;
            this.sold               = client.sold;
            this.new_client         = false;

            if(this.client_visit_info.visit_last_date )
                this.client_visit_info.visit_last_date  = client.visit_last_date;
            
            if(this.client_visit_info.count_visits )
                this.client_visit_info.count_visits     = client.count_all_visits;
        }
        console.log('in set');
        console.log(this);
    }
}
